import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionChanged: false,
    };
  }

  handleOptionChange = (e) => {
    const { onOptionChange } = this.props;
    if (onOptionChange) {
      onOptionChange(e.target.value);
    }
    this.setState({ optionChanged: true });
  };

  render() {
    const { props } = this;
    const { isBackspaceClearEnabled } = props;
    const { optionChanged } = this.state;

    const handleClick = (e) => {
      if (props.onOpen) {
        props.onOpen(this.props.value);
      }
      props.onTrigger(e);
    };

    const onInputChange = _.debounce((value) => {
      if (props.onSearch) {
        return props.onSearch(value);
      }

      props.onUpdateState({
        options: props.options.filter(
          (item) => item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1
        ),
      });
    }, 300);

    const handleChange = (e) => {
      onInputChange(e.target.value);
      this.handleOptionChange(e);
      if (e.target.value) {
        props.onUpdateState({
          inputValue: e.target.value,
          showSelected: false,
        });
      } else {
        props.onUpdateState({ inputValue: e.target.value, showSelected: true });
      }
    };

    const handleKeyPress = (e) => {
      if (
        isBackspaceClearEnabled &&
        e.key === 'Backspace' &&
        e.target.value === ''
      ) {
        props.onUpdateState({ selected: {} });
        if (props.onClearSelected) {
          props.onClearSelected();
        }
      }
    };

    const handleClear = () => {
      props.onUpdateState({ inputValue: '', selected: {} });
      if (props.onClearSelected) {
        props.onClearSelected();
      }
    };

    const isSelectedActive =
      props.showSelectedInInput &&
      props.state.selected.value &&
      props.state.showSelected
        ? 'selectedActive'
        : '';
    return (
      <React.Fragment>
        <div
          id={props.id}
          className={clsx(
            'selectedTrigger',
            props.className,
            props.open && 'active',
            props.disabled && 'disabled tw-bg-cfo-grey-500',
            props.isAiGenerated && '!tw-bg-[rgba(240,232,250,1)]',
            props.isManualExpensePrefilled &&
              props.hasSelected &&
              !props.hasSelectionChanged &&
              !optionChanged &&
              '!tw-bg-cfo-blue-200'
          )}
          onClick={handleClick}
        >
          {props.showSelectedInInput &&
            props.state.showSelected &&
            (props.renderSelected && props.state.selected.value ? (
              props.renderSelected(props.state.selected)
            ) : (
              <span
                className={clsx(isSelectedActive, props.selectedSpanClasses)}
              >
                {props.state.selected.value && props.state.selected.label}
              </span>
            ))}
          <input
            type="text"
            className={clsx(
              isSelectedActive,
              this.props.value !== '' && 'hasInput',
              'disabled:!tw-bg-cfo-grey-500',
              props.isAiGenerated && '!tw-bg-[rgba(240,232,250,1)]',
              props.isManualExpensePrefilled &&
                props.hasSelected &&
                !props.hasSelectionChanged &&
                !optionChanged &&
                '!tw-bg-cfo-blue-200'
            )}
            onChange={handleChange}
            placeholder={
              props.placeholder &&
              ((props.showSelectedInInput && !props.state.selected.value) ||
                !props.showSelectedInInput)
                ? props.placeholder
                : ''
            }
            onKeyDown={handleKeyPress}
            value={this.props.value}
            disabled={props.disabled}
            autoComplete={'new-text'}
          />
          {props.searchIcon ? (
            props.searchIcon
          ) : (
            <i className="material-icons">arrow_drop_down</i>
          )}
        </div>
        {props.clearIcon &&
          ((props.state.selected || {}).value || this.props.value) && (
            <a className="clearIcon" onClick={handleClear}>
              {props.clearIcon}
            </a>
          )}
      </React.Fragment>
    );
  }
}

export default Input;
